
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/covid-19-resources/covid-19-federal-resources",
      function () {
        return require("private-next-pages/covid-19-resources/covid-19-federal-resources.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/covid-19-resources/covid-19-federal-resources"])
      });
    }
  